"use strict";

var NestedFormGroup, React, ReactBootstrap, classnames;

React = require("react");

classnames = require("classnames");

ReactBootstrap = require("react-bootstrap");

NestedFormGroup = React.createClass({
  displayName: "NestedFormGroup",

  getInitialState: function getInitialState() {
    var ref, ref1;
    return {
      collapsed: (ref = this.props.formDef.collapsed) != null ? ref : false,
      collapsable: (ref1 = this.props.formDef.collapsable) != null ? ref1 : true
    };
  },
  toggleCollapse: function toggleCollapse(event) {
    return this.setState({
      collapsed: !this.state.collapsed
    });
  },
  renderHeader: function renderHeader() {
    var ref;
    if ((ref = this.props.title) != null ? ref : this.props.nestedIndex != null) {
      return React.createElement(
        "div",
        { className: "panel-heading", onClick: this.state.collapsable ? this.toggleCollapse : "" },
        React.createElement(
          "h3",
          { className: "panel-title" },
          this.renderCollapsedIndicador(),
          " ",
          this.props.title
        ),
        this.renderDeleteButton()
      );
    }
  },
  renderCollapsedIndicador: function renderCollapsedIndicador() {
    if (this.state.collapsable) {
      if (this.state.collapsed) {
        return React.createElement(ReactBootstrap.Glyphicon, { glyph: "chevron-right" });
      } else {
        return React.createElement(ReactBootstrap.Glyphicon, { glyph: "chevron-down" });
      }
    }
  },
  renderDeleteButton: function renderDeleteButton() {
    if (this.props.nestedIndex != null) {
      return React.createElement(
        "div",
        { className: "pull-right panel-btns" },
        React.createElement(
          ReactBootstrap.Button,
          { onClick: this.props.removeNestedForm },
          React.createElement(Icon, { type: "imoon", name: "remove2" })
        )
      );
    }
  },
  render: function render() {
    var classes;
    classes = classnames({
      "panel-body": true,
      hidden: this.state.collapsed
    });
    return React.createElement(
      "div",
      { className: "panel panel-visible" },
      this.renderHeader(),
      React.createElement(
        "div",
        { className: classes },
        this.props.children
      ),
      React.createElement(
        "div",
        { className: "panel-footer" },
        React.createElement(
          ReactBootstrap.Button,
          { onClick: this.props.addNestedForm },
          "Add an element"
        )
      )
    );
  }
});

module.exports = NestedFormGroup;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/NestedFormGroup.js
 ** module id = 553
 ** module chunks = 0
 **/